import React, { useMemo, useState } from "react";
import { Conflict } from "@opstel/query/v2/models/conflict";
import { ConflictItem } from "./ConflictItem";

export interface ConflictOverviewProps {
  readonly conflicts: Conflict[];
}

export function ConflictSidePanel({ conflicts }: ConflictOverviewProps): React.JSX.Element {
  const [expandedConflictId, setExpandedConflictId] = useState<string | null>(null);
  const sortedConflicts = useMemo(
    () =>
      conflicts.toSorted(
        (a, b) => a.timeInterval.start.toMillis() - b.timeInterval.start.toMillis(),
      ),
    [conflicts],
  );

  const handleToggle = (conflictId: string) => {
    setExpandedConflictId((prev) => (prev === conflictId ? null : conflictId));
  };

  return (
    <div className="overflow-x-hidden overflow-y-auto">
      <div className="flex items-baseline gap-s">
        <h2>Conflicten</h2>
        {sortedConflicts.length > 0 && (
          <tractie-tag
            color="blue"
            appearance="subtle"
            label={sortedConflicts.length.toString()}
            size="m"
          />
        )}
      </div>

      <div className="grid overflow-x-hidden overflow-y-auto">
        {sortedConflicts.length > 0 ? (
          sortedConflicts.map((conflict) => (
            <ConflictItem
              key={conflict.id}
              conflict={conflict}
              isExpanded={expandedConflictId === conflict.id}
              onToggle={() => handleToggle(conflict.id)}
            />
          ))
        ) : (
          <span className="block p-xs text-center text-m leading-l font-normal text-subtle">
            Er zijn geen conflicten gevonden
          </span>
        )}
      </div>
    </div>
  );
}
